<div [formGroup]="form">
  <div class="form-spacing">
    <!-- Data richiesta (View only) -->
    <div class="column">
      <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
      <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
    </div>

    <!-- Note / Dichiarazione -->
    <div class="column">
      <p class="text-dark" [innerHTML]="'selfservice-request.first-employment.notes.label' | translate"></p>
    </div>

    <!-- Pre2007 / Post2006: iscrizione a forme pensionistiche (una sola opzione) -->
    <div class="column">
      <!-- Pre2007: da una data antecedente il 1° gennaio 2007 -->
      <div class="row gap-small mb-2">
        <p-radiobutton inputId="isBeforeJan2007True" formControlName="isBeforeJan2007" [value]="true"></p-radiobutton>
        <label for="isBeforeJan2007True" class="label">
          {{ 'selfservice-request.first-employment.enrollment-date.before-2007.label' | translate }}
        </label>
      </div>

      <!-- Post2006: da una data successiva al 31/dicembre 2006 -->
      <div class="row gap-small">
        <p-radiobutton inputId="isBeforeJan2007False" formControlName="isBeforeJan2007" [value]="false"></p-radiobutton>
        <label for="isBeforeJan2007False" class="label">
          {{ 'selfservice-request.first-employment.enrollment-date.after-2006.label' | translate }}
        </label>
      </div>

      @if (form.get('isBeforeJan2007')?.invalid && form.get('isBeforeJan2007')?.touched) {
        <small class="text-red-500 p-error">
          {{ 'selfservice-request.first-employment.validation.required' | translate }}
        </small>
      }
    </div>
  </div>
</div>
